import axios from "axios";
import { compress } from "../helpers/common.helper";
const apiUri = import.meta.env.GATEWAY_URI;

export default function useAuth() {
  const signIn = async (email, password) => {
    const result = await axios.post(`${apiUri}/api/v1/auth/signIn`, null, {
      auth: {
        username: email,
        password,
      },
    });
    return result.data?.data;
  };

  const refreshToken = async () => {
    const result = await axios.post(
      `${apiUri}/api/v1/auth/refreshToken`,
      null,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refreshToken")}`,
        },
      }
    );
    return result.data?.data;
  };

  const signInExternal = async (userId, externalType) => {
    const result = await axios.post(`${apiUri}/api/v1/auth/signIn`, null, {
      headers: {
        "Content-Type": "text/plain",
        "x-auth-type": externalType,
        "x-auth-value": userId,
      },
    });
    return result.data?.data;
  };

  const createRegistration = async (email) => {
    const _body = compress(JSON.stringify({ email }));

    const result = await axios.post(`${apiUri}/api/v1/registrations`, _body, {
      headers: {
        "Content-Type": "text/plain",
      },
    });
    return result.data?.data;
  };

  const confirmRegistration = async (id, otp) => {
    const _body = compress(JSON.stringify({ otp }));

    const result = await axios.post(
      `${apiUri}/api/v1/registrations/${id}/otp/confirm`,
      _body,
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    return result.data?.data;
  };

  const resendOtp = async (id) => {
    const result = await axios.post(
      `${apiUri}/api/v1/registrations/${id}/otp/resend`,
      null
    );
    return result.data?.data;
  };

  const createPasswordReset = async (email) => {
    const _body = compress(JSON.stringify({ email }));

    await axios.post(`${apiUri}/api/v1/passwordResets`, _body, {
      headers: {
        "Content-Type": "text/plain",
      },
    });
  };

  const getPasswordReset = async (id) => {
    const result = await axios.get(`${apiUri}/api/v1/passwordResets/${id}`);
    return result.data?.data;
  };

  const resetPassword = async (userId, password, resetPasswordId) => {
    const _body = compress(JSON.stringify({ password }));

    axios.patch(`${apiUri}/api/v1/users/${userId}/password`, _body, {
      headers: {
        "Content-Type": "text/plain",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "x-password-reset-id": resetPasswordId,
      },
    });
  };

  const checkEmailExistence = async (email) => {
    const result = await axios.get(`${apiUri}/api/v1/registrations/user`, {
      params: {
        email,
      },
    });

    return result.data?.data;
  };

  const adminSignIn = async (username, password) => {
    const result = await axios.post(`${apiUri}/api/v1/auth/signIn`, null, {
      auth: {
        username,
        password,
      },
      headers: {
        "x-auth-type": "staff",
      },
    });
    return result.data?.data;
  };

  return {
    signIn,
    createRegistration,
    confirmRegistration,
    resendOtp,
    createPasswordReset,
    getPasswordReset,
    resetPassword,
    checkEmailExistence,
    adminSignIn,
    signInExternal,
    refreshToken,
  };
}
